// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, Timestamp, serverTimestamp, FieldValue } from "firebase/firestore"; // Added serverTimestamp, FieldValue
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // Make sure this is imported

const firebaseConfig = {
  apiKey: "AIzaSyDq3D0CVr3SVXjCql276e6rqQ2NUdVgrbI",
  authDomain: "chodoc-business-app.firebaseapp.com",
  databaseURL: "https://chodoc-business-app-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chodoc-business-app",
  storageBucket: "chodoc-business-app.appspot.com",
  messagingSenderId: "593702857837",
  appId: "1:593702857837:web:3e3c9db84bc8d34662a364",
  measurementId: "G-8SLTCD9XCJ"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app); // Initialize Firebase Functions

// Export serverTimestamp and FieldValue as they are useful
export { db, auth, storage, functions, Timestamp, serverTimestamp, FieldValue }; // Export thêm functions, serverTimestamp, FieldValue